<div class="container">
    <h2>Emails for Device Action Required:</h2>
    @if(loading){
    <div class="spinner-container">
        <mat-spinner></mat-spinner>
    </div>
    }@else{
    @if(emailsFormControl.length === 0){
    <button mat-icon-button (click)="addNewEmail()" style="border: 0px;"><mat-icon>add</mat-icon></button>
    }
    <div class="emails">
        @for(email of emailsFormControl.controls;track email; let last = $last; let i = $index){
        <div class="email-entry">
            <div class="form-container">
                <mat-form-field class="email-field" subscriptSizing="dynamic">
                    <mat-label>Email:</mat-label>
                    <input matInput [formControl]="email">
                    <button matSuffix mat-icon-button aria-label="Remove" (click)="emailsFormControl.removeAt(i)">
                        <mat-icon>remove</mat-icon>
                    </button>
                    @if (email.errors?.['required'] &&
                    email.touched) {
                    <mat-error>This field is required</mat-error>
                    }@else if(email.errors?.['email'] && email.touched){
                    <mat-error>Invalid Email</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="button-container">
                @if(last){

                <button mat-icon-button (click)="addNewEmail()" style="border: 0px;"><mat-icon>add</mat-icon></button>
                }

            </div>
        </div>
        }
    </div>

    <div class="buttons">
        <button mat-raised-button (click)="saveEmails()">Save</button>
        <button mat-raised-button (click)="cancel()">Cancel</button>
    </div>
    }
</div>